<template>
  <div class="applications__wrapper education-container education-container--wide">
    <div class="applications__filters">
      <ApplicationsFilter title="Filter by user group" :options="userGroups" :loading="loadingApplications" @toggle-filter-active="toggleUserGroupActive"></ApplicationsFilter>
    </div>
    <div class="applications__results">
      <div class="applications__results-title-wrapper">
        <h3 class="applications__results-title">
          <font-awesome-icon v-if="loadingApplications" class="fas fa-spinner applications__loading-spinner" icon="spinner" />
          <span v-if="!loadingApplications">{{ applicationsCount }}</span> Applications
        </h3>
      </div>
      <ApplicationsGrid id="applications-results" :applications="applications" role="tabpanel" aria-labelledby="applications-tab" />
      <div v-if="nextApplicationUrl || loadingMoreApplications" class="applications__show-more">
        <button v-if="nextApplicationUrl" class="c-button c-button--secondary" @click="loadMoreApplications">
              Show more
            </button>
        <font-awesome-icon v-if="loadingMoreApplications" class="fas fa-spinner applications__loading-spinner" icon="spinner" />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ApplicationsFilter from './ApplicationsFilter.vue';
  import ApplicationsGrid from './ApplicationsGrid.vue';
  import {
    FontAwesomeIcon
  } from '@fortawesome/vue-fontawesome';
  
  export default {
    name: 'Applications',
    components: {
      ApplicationsFilter,
      ApplicationsGrid,
      FontAwesomeIcon
    },
    props: {},
    data() {
      return {
        applications: [],
        userGroups: [],
        filters: [],
        displayMobileFilters: false,
        loadingApplications: true,
        nextApplicationUrl: null,
        loadingMoreApplications: false,
        applicationsBaseUrl: '/api/application_overview_page',
      };
    },
    computed: {
      applicationsCount() {
        return this.applications ? `${this.applications.length} ` : '';
      },
    },
    mounted() {
      // Set which view to use
      this.initView();
  
      const userGroupPromise = axios.get('/api/user_group');
  
      Promise.all([
        userGroupPromise,
      ]).then(response => {
        this.initUserGroups(response[0].data.data);
        this.initApplications();
      });
    },
    methods: {
      initView() {
        const params = new URLSearchParams(document.location.search.substring(1));
      },
      initUserGroups(data) {
        this.userGroups = data.map(item => {
          return {
            id: item.id,
            label: item.attributes.name,
            active: false,
          };
        });
      },
      initApplications() {
        const params = new URLSearchParams(document.location.search.substring(1));
        const userGroupParams = params.getAll('user_group');
  
        this.initParams(userGroupParams, this.userGroups, 'user_group');
  
        this.updateApplications();
      },
      initParams(params, data, formats) {
        params.forEach((param) => {
          // Replaces '_' with ' '
          const matchedFilter = data.find((item) => item.label === param.replace(/_/g, ' '));
  
          if (matchedFilter) {
            const currentFilter = `filter[${formats}.id][value]=${matchedFilter.id}`;
            this.filters.push(currentFilter);
  
            matchedFilter.active = !matchedFilter.active;
          }
        });
      },
      /* Generates a request url using active filters and makes ajax call for applications */
      updateApplications() {
        // generate url from all active filters
        const url = this.generateApplicationRequestUrl();
        // Make a request for applications using the generated url
        this.loadingApplications = true;
        this.applications = [];
        this.nextApplicationUrl = null;
        axios
          .get(url)
          .then(response => {
            this.applications = response.data.data
              .map((application) => ({
                id: application.id,
                title: application.attributes.title,
                description: application.attributes.field_banner_body_text,
                cardLink: application.attributes.path.alias,
                externalLink: application.attributes.external_link,
                buttonUsesEsl: application.attributes.button_uses_esl
              }));
            if (response.data.links.next) {
              this.nextApplicationUrl = response.data.links.next.href;
            }
            this.loadingApplications = false;
          });
      },
  
      /* Generate the application request url from all active filters */
      generateApplicationRequestUrl() {
        // Generate arrays for all active filters
        const activeUserGroups = this.getActiveFilterUrls(this.userGroups, 'user_group');
  
        // Join all filters into one string
        const allActiveFilters = activeUserGroups;
  
        // Create application request url
        const applicationRequestUrl = '/api/application_overview_page?sort=title&include=user_group' +
          `${allActiveFilters
                            ? `&${allActiveFilters}`
                            : ''}`;
  
        return applicationRequestUrl;
      },
  
      // Returns an array of active filters, each string in the array is formatted for a applications api
      // request
      getActiveFilterUrls(data, name) {
        return data.filter(item => item.active).map(item => {
          return `filter[${name}.id][value]=${item.id}`;
        });
      },
      toggleUserGroupActive(index) {
        // this.userGroups[index].active = !this.userGroups[index].active;
         this.userGroups = this.userGroups.map((item, currentIndex) => {
        if (currentIndex === index) {
          return {...item, active: !item.active};
        }
        return {...item, active: false};
      });
        this.updateUrlParameters();
        this.updateApplications();
      },
      /* Updates the url parameters to match the active filters */
      updateUrlParameters() {
        // Create new params and add all active filters
        const params = new URLSearchParams();
        this.appendActiveFilterParams(params, this.userGroups, 'user_group');
  
        // Compare to previous state and push to history
        window.history.pushState({}, '', `${window.location.pathname}${params.toString() ? `?${params}` : ''}`);
      },
      appendActiveFilterParams(params, data, name) {
        data.filter(item => item.active).forEach(item => {
          params.append(name, item.label.replace(/ /g, '_'));
        });
      },
      toggleMobileFilters() {
        this.displayMobileFilters = !this.displayMobileFilters;
      },
      loadMoreApplications() {
        const requestUrl = this.nextApplicationUrl;
        this.nextApplicationUrl = null;
        this.loadingMoreApplications = true;
        axios
          .get(requestUrl)
          .then(response => {
            this.applications = this.applications.concat(response.data.data);
            if (response.data.links.next) {
              this.nextApplicationUrl = response.data.links.next.href;
            }
            this.loadingMoreApplications = false;
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  $filter-width: 14rem;
  $filter-gap: gap-size(calc(3/4));
  .applications {
    &__wrapper {
      display: flex;
      @include education-breakpoint-mobile-down {
        flex-direction: column;
      }
    }
    &__tabs-wrapper {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    &__tabs {
      width: 100%;
      display: flex;
      margin-bottom: gap-size(1);
    }
    &__tab {
      @include reset-button;
      width: 50%;
      padding-bottom: gap-size(calc(1/2));
      border-bottom: $border-width-extra-bold solid $color-white;
      font-family: $font-family;
      font-size: $font-size-xsmall;
      font-weight: $font-weight-medium;
      color: $color-dark-grey;
      text-transform: uppercase;
      cursor: pointer;
      @include hover-focus-active {
        color: $color-blue;
      }
      &--active {
        color: $color-charcoal-mid;
        border-color: $color-blue;
        cursor: default;
        @include hover-focus-active {
          color: $color-charcoal-mid;
        }
      }
    }
    &__filters {
      padding-right: 2rem;
      max-width: 15rem;
    }
    &__close-button {
      position: fixed;
      top: 1rem;
      right: 1rem;
      border: none;
      background: transparent;
      color: $color-charcoal-mid;
      padding: 0;
      font-size: $font-size-large;
    }
    &__apply-button {
      position: fixed;
      bottom: 1rem;
      left: 1rem;
      width: calc(100% - #{gap-size(1)});
      padding: 0.88rem gap-size(calc(1/2));
      color: $color-white;
      border: $border-button;
      background: $color-blue;
      font-weight: $font-weight-medium;
      text-transform: uppercase;
    }
    &__results {
      width: 100%;
    }
    &__results-title-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding-bottom: gap-size(calc(1/2));
      border-bottom: $border-width solid $color-light-grey;
    }
    &__results-title {
      font-size: $font-size-xsmall;
      line-height: 1;
      letter-spacing: 0.013rem;
      text-transform: uppercase;
      color: $color-dark-grey;
    }
    &__loading-spinner {
      animation: spin-animation 1s infinite;
      display: inline-block;
    }
    &__show-more {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: gap-size(1);
    }
  }
  
  @keyframes spin-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
</style>
